import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffectOnce, useQueryParam } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { REACT_APP_TAXES_KEY_SEED } from '../../config/settings/environment'
import routes from '../../config/settings/routes'
import { useCsrfToken } from '../../modules/hooks/security'
import { onGetTaxesKeyTokenThunk } from './TaxesKeyAuth.actions'
import { Root } from './TaxesKeyAuth.styles'

/**
 * The TaxesKeyAuth' container.
 */
const TaxesKeyAuth = () => {
  const dispatch = useDispatch()
  const { error, isRecoveryAdmin, loading } = useSelector(state => state.taxesKeyAuth)
  const navigate = useNavigate()
  const csrfToken = useCsrfToken(REACT_APP_TAXES_KEY_SEED)
  const code = useQueryParam('code')

  useEffectOnce(() => {
    dispatch(onGetTaxesKeyTokenThunk({ csrfToken, code }))
  })

  useEffect(() => {
    if (loading) {
      return
    }

    if (error) {
      return navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'business-search' } })
    }

    if (isRecoveryAdmin) {
      return navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'recovery-company' } })
    }

    navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'business-info' } })
  }, [isRecoveryAdmin, loading])

  return (
    <Root>
      <Spinner />
    </Root>
  )
}

export default TaxesKeyAuth
